import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { BreakString } from 'foundations-components/transitional/components/BreakString';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Image } from 'foundations-components/transitional/components/Image';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AppCard({
  appCard,
  showBottomBorder
}) {
  const {
    title,
    description,
    imageUrl,
    objects,
    placement
  } = appCard;
  return /*#__PURE__*/_jsx(View, {
    borderBlockEndWidth: showBottomBorder ? '100' : undefined,
    borderBlockEndColor: showBottomBorder ? 'border-core-default' : undefined,
    borderBlockEndStyle: showBottomBorder ? 'solid' : undefined,
    paddingBlock: "400",
    children: /*#__PURE__*/_jsxs(Grid, {
      children: [/*#__PURE__*/_jsxs(GridItem, {
        size: {
          sm: 12,
          md: 7
        },
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(BreakString, {
            children: title
          })
        }), /*#__PURE__*/_jsx(Text, {
          whiteSpace: "pre-line",
          children: /*#__PURE__*/_jsx(BreakString, {
            children: description
          })
        }), /*#__PURE__*/_jsxs(View, {
          paddingBlockStart: "200",
          children: [/*#__PURE__*/_jsxs(Text, {
            children: [/*#__PURE__*/_jsx(Text, {
              typography: "heading-50",
              as: "span",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "detailsPage.functionalityCard.tabs.appCards.objects"
              })
            }), objects.join(', ')]
          }), /*#__PURE__*/_jsxs(Text, {
            children: [/*#__PURE__*/_jsx(Text, {
              typography: "heading-50",
              as: "span",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "detailsPage.functionalityCard.tabs.appCards.placement"
              })
            }), placement]
          })]
        })]
      }), /*#__PURE__*/_jsx(GridItem, {
        size: {
          sm: 12,
          md: 5
        },
        children: /*#__PURE__*/_jsx(Image, {
          alt: title,
          src: imageUrl,
          responsive: true,
          shape: "rounded"
        })
      })]
    })
  });
}